import React from "react";
import { Flex, TextButton } from "../../../common/styles/commonStyles";

function PlaylistsNavBar({ onPlaylistSelect }) {
  return (
    <Flex
      padding={12}
      justifyContent="space-between"
      width="100%"
      backgroundColor="rgba(0,0,0,0.1)"
    >
      <TextButton
        backgroundColor="#df65dd"
        onClick={() => onPlaylistSelect("new")}
      >
        등록
      </TextButton>
    </Flex>
  );
}

export default PlaylistsNavBar;
